module.exports = function() {
  return new Worker(__webpack_public_path__ + "05093d010dc028daf0e9.worker.js");
};